import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'


const CreateCampaign = () => {

  const navigate = useNavigate();

  const options = [
    {
      name: 'Basic Info',
      link: 'basic-info',
    },
    {
      name: 'Media',
      link: 'media',
    },
    {
      name: 'Parameters',
      link: 'parameters',
    },
    {
      name: 'Lead Generation',
      link: 'lead-generation',
    },
  ];

  return (
    <>
      <section className='w-100 px-3 pt-3 overflow-y-scroll scrollbar-hidden' style={{ backgroundColor: '#ecf6fa' }}>
        {/* Header */}
        <div className='bg-light p-3 rounded-3 d-flex flex-wrap align-items-center gap-3'>
          <h4 className='mb-0 text-primary'>Siddharth Dongre</h4>

          <select className="form-select w-auto me-auto">
            <option>Open this select menu</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>

          <button type="button" className='btn btn-primary'>View All Campaign</button>

          <button type="button" className='btn btn-primary'>Review and Publish</button>

          <button type="button" className='bg-white border-0 shadow-sm p-1 rounded-1'>
            <img src="/images/icons/three-dot-black.svg" style={{ height: '20px' }} alt="three-dot-black" />
          </button>
        </div>

        {/* Options */}
        <div className='d-flex flex-wrap gap-3 align-items-center justify-content-between my-3'>
          {
            options.map((value, index) => (
              <div className={`${window.location.href.includes(value.link) ? 'bg-primary text-white' : 'bg-light text-secondary'} cursor-pointer flex-grow-1 py-2 rounded-3 text-center fs-5`} onClick={() => navigate(value.link)} key={index}>{value.name}</div>
            ))
          }
        </div>

        <Outlet />
      </section> 
    </>
  )
}

export default CreateCampaign
